import React, { ReactElement } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';

type SellerConfirmationStepProps = {
  completionRedirect?: string;
  formMessage?: ReactElement[];
  finalStep?: number;
}

type FormErrorsProps = {
  formMessage: ReactElement[];
}

const FormErrors: React.FC<FormErrorsProps> = ({ formMessage }) => {
  return (
    <Alert variant="danger" className="mt-4">
      <ul>
        {
          formMessage.map((message) => {
            return <li key={message.key}>{message}</li>;
          })
        }
      </ul>
    </Alert>
  );
};

const SellerConfirmationStep: React.FC<SellerConfirmationStepProps> = ({
  completionRedirect,
  formMessage,
  finalStep,
}) => {
  const finalStepMessages = (content: string) => {
    const messages = {
      default: {
        header: "You're all set!",
        body: `Your application was approved! You can now create new puppy ads.
          Please note that we always manually review your first listing to ensure it meets our trust & safety standards.
          This means that it might take some time for your first ad to be published.`,
        button: 'Create first ad',
      },
      3: {
        header: "You're all set!",
        body: "You've successfully enabled two factor authentication for your account.",
        button: 'Back to Settings',
      },
    };
    const step = finalStep || 'default';
    return messages[step][content];
  };

  return (
    <Row className="seller-confirmation-step p-md-6 p-3 py-5">
      <Col xs={12} className="d-flex justify-content-center align-items-start flex-column">
        <h2 className="mb-5">
          {finalStepMessages('header')}
        </h2>
        <p className="mb-5 text-muted">
          {finalStepMessages('body')}
        </p>
        <a className="btn btn-outline-primary py-2 px-4 font-weight-bold" href={completionRedirect}>
          {finalStepMessages('button')}
        </a>
        {
          !!formMessage && <FormErrors formMessage={formMessage} />
        }
      </Col>
    </Row>
  );
};

export default SellerConfirmationStep;
